import { render } from "./integrate.vue?vue&type=template&id=68aa718c&scoped=true"
const script = {}

import "./integrate.vue?vue&type=style&index=0&id=68aa718c&lang=scss&scoped=true"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68aa718c"]])

export default __exports__